import { CenterMarkControlBtn } from "../components/mapController/centerMarkControlBtn/centerMarkControlBtn";
import { IndexMapControlBtn } from "../components/mapController/indexMapControlBtn/indexMapControlBtn";
import { MoveControlBtn } from "../components/mapController/moveControlBtn/moveControlBtn";
import { TerrainControlBtn } from "../components/mapController/terrainControlBtn/TerrainControlBtn";

/* ******************
 * マップのコントローラーを追加
 * ******************/ 
export const addMapController = (
  map: maplibregl.Map, 
  isDesktop: boolean,
  setIsIndexMapOpen: () => void | undefined, 
  setIsTerrainControlerOpen: () => void | undefined,
  setIsCenterMarkControlOpen: () => void | undefined
) => {
  map.addControl(new window.geolonia.NavigationControl(), 'top-right');             // ナビゲーションコントロールを追加
  map.addControl(new window.geolonia.GeolocateControl({                             // 現在地ボタンを追加          
    positionOptions: { enableHighAccuracy: true },
    trackUserLocation: true
  }), 'top-right');

  map.addControl(new TerrainControlBtn(setIsTerrainControlerOpen), 'top-right');    // 3D表示

  if (isDesktop) { 
    map.addControl(new IndexMapControlBtn(setIsIndexMapOpen), 'top-right');               // 索引図を追加
    map.addControl(new CenterMarkControlBtn(setIsCenterMarkControlOpen), 'top-right');    // 中心マークを追加
    map.addControl(new MoveControlBtn(), 'top-right');                                    // 移動ボタンを追加
  }
}
 